import { SearchInput } from 'react-admin'

const RetailerRepresentativeListFilter = [
    <SearchInput variant="outlined" placeholder="Search name" source="name" alwaysOn />,
    <SearchInput variant="outlined" placeholder="Search email" source="email" />
]

export default RetailerRepresentativeListFilter
